import Vue from 'vue'
import App from "./App.vue";
import router from "./router";
import "./utils/axios-config";
import store from "./store";
import "amfe-flexible";
import "amfe-flexible/index.js";
import schema from "async-validator";
import {Alert, Confirm, Toast, Loading} from 'wc-messagebox';
import 'wc-messagebox/style.css';

import { Form,Icon,Swipe, SwipeItem,Cascader,Field, CellGroup,Popup,Picker,RadioGroup, Radio,Checkbox, CheckboxGroup,Button,Overlay } from 'vant';
Vue.use(Form);
Vue.use(Icon);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Cascader);
Vue.use(Field);
Vue.use(CellGroup);
Vue.use(Popup);
Vue.use(Picker);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Button);
Vue.use(Overlay);
Vue.use(Alert);
Vue.use(Confirm);
Vue.use(Toast);
Vue.use(Loading);

Vue.prototype.$validator = function (rule) {
  return new schema(rule);
};


Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
